<template lang="pug">
  .not-found-in-shop
    h2.text-center.text-18.lg-text-24
      slot
    products-collection-thumb.mt-82.lg-mt-100.mx-auto.max-w-400(:rt="{name: 'products'}", :image="image") Browse Our Catalogue
</template>

<script>
import { mapState } from 'vuex'
import ProductsCollectionThumb from '@/components/Shop/ProductsCollectionThumb'
export default {
  name: 'NotFoundInShop',
  computed: {
    ...mapState({
      image: state => state.site && state.site.hostem_404_image
    })
  },
  components: { ProductsCollectionThumb }
}
</script>

<style>
</style>
